const appEnv = import.meta.env.VITE_APP_ENV?.trim() || import.meta.env.MODE;

export const env = {
  supplierApiUrl:
    import.meta.env.VITE_SUPPLIER_API_URL?.trim() ||
    "https://api.kithub24.com/supplier",
  firebaseVapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY?.trim() || "",
  version: __APP_VERSION__,
  appEnv,
  isStaging: appEnv === "staging",
} as const;
